import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Select,
  Table,
  Divider,
  message,
  Tooltip,
  Popconfirm,
  Modal,
} from "antd";
import {
  fetchEquipmentList,
  fetchDeleteEquipment,
  fetchHardwareVersionList,
} from "../../../api/equipment";
import AddEquipmentModal from "../components/AddEquipment";
import NProgress from "nprogress";
import VersionUpdate from "../components/VersionUpdate";
import { fetchHardwarePosition } from "../../../api/version";
const BreadCrumbData = [
  { path: "/page/equipment/retailequipment", name: "设备" },
  { path: "/page/equipment/retailequipment", name: "零售设备" },
];
const { Option } = Select;
const { Column } = Table;
class RetailEquipment extends React.Component {
  state = {
    visible: false,
    list: [],
    total: 0,
    listQuery: {
      capsuleNo: "",
      companyName: "",
      status: "ALL",
      pageNum: 1,
      pageSize: 10,
      capsuleType: "",
    },
    equipmentInfo: {
      capsuleNo: "",
      roboId: "",
      templateId: "",
      capsuleId: "",
      capsuleType: "",
    },
    versionUpdateVisible: false,
    viewHardwareVersionVisible: false,
    hardwareVersionList: [],
    selectedRows: [],
    capsuleIdList: [],
    selectedRowKeys: [],
    hardwarePositionList: [],
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { companyName, capsuleNo, status, capsuleType } = values;
        this.setState(
          {
            listQuery: {
              ...this.state.listQuery,
              capsuleNo,
              status,
              companyName,
              pageNum: 1,
              capsuleType,
            },
          },
          () => {
            this.getEquipmentList();
            message.success("搜索成功");
          }
        );
      }
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
      equipmentInfo: {
        capsuleNo: "",
        roboId: "",
        templateId: "",
        capsuleId: "",
        capsuleType: "",
      },
    });
  };
  async componentDidMount() {
    NProgress.start();
    await this.getEquipmentList();
    this.getHardwarePositionList();
    NProgress.done();
  }
  //获取硬件位置列表
  getHardwarePositionList = () => {
    fetchHardwarePosition().then((res) => {
      this.setState({
        hardwarePositionList: res.data,
      });
    });
  };
  getEquipmentList = () => {
    fetchEquipmentList(this.state.listQuery).then((res) => {
      this.setState({
        list: res.data.list,
        total: res.data.total,
      });
      setTimeout(() => {
        console.log(document.getElementsByClassName("ant-checkbox"));
        res.data.list.forEach((item, index) => {
          if (!item.bind) {
            document.getElementsByClassName("ant-checkbox")[
              index + 1
            ].style.display = "none";
          }
        });
      }, 0);
    });
  };
  editEquipment = (value) => {
    const { capsuleNo, roboId, templateId, capsuleId, type, templateName } =
      value;
    this.setState({
      visible: true,
      equipmentInfo: {
        capsuleNo,
        roboId,
        templateId,
        capsuleId,
        type,
        templateName,
      },
    });
  };
  confirmDelete = (value) => {
    fetchDeleteEquipment(value).then((res) => {
      if (res.success) {
        message.success("删除成功");
        this.getEquipmentList();
      }
    });
  };
  versionUpdateCancel = () => {
    this.setState({
      versionUpdateVisible: false,
    });
  };
  versionUpdateOpen = (record) => {
    var capsuleIdList = [];
    if (!record.capsuleId) {
      //批量更新
      this.state.selectedRows.forEach((item) => {
        capsuleIdList.push(item.capsuleId);
      });
    }

    this.setState({
      versionUpdateVisible: true,
      capsuleIdList: record.capsuleId ? [record.capsuleId] : capsuleIdList,
    });
  };
  //清空选中项
  clearSelected = () => {
    this.setState({
      selectedRowKeys: [],
    });
  };
  //查看硬件版本
  viewHardwareVersion = (record) => {
    this.getHardwareList(record.capsuleId);
    this.setState({
      viewHardwareVersionVisible: true,
    });
  };
  viewHardwareVersionCancel = () => {
    this.setState({
      viewHardwareVersionVisible: false,
      hardwareVersionList: [],
    });
  };
  //获取硬件列表
  getHardwareList = (capsuleId) => {
    fetchHardwareVersionList({ capsuleId }).then((res) => {
      this.setState({
        hardwareVersionList: res.data,
      });
    });
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      list,
      listQuery,
      total,
      visible,
      equipmentInfo,
      versionUpdateVisible,
      viewHardwareVersionVisible,
      hardwareVersionList,
      selectedRows,
      capsuleIdList,
      selectedRowKeys,
      hardwarePositionList,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="searchTitle">
          <Row>
            <Col span={20}>
              <Form layout="inline" onSubmit={this.handleSubmit}>
                <Form.Item>
                  {getFieldDecorator(
                    "capsuleType",
                    {}
                  )(
                    <Select
                      placeholder="全部类型"
                      style={{ width: 120 }}
                      allowClear
                    >
                      <Option value="EV200">EV200</Option>
                      <Option value="X5">X5</Option>
                    </Select>
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "capsuleNo",
                    {}
                  )(
                    <Input
                      style={{ width: 160 }}
                      placeholder="设备编号"
                      allowClear
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "companyName",
                    {}
                  )(
                    <Input
                      style={{ width: 160 }}
                      placeholder="使用商户"
                      allowClear
                    />
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator(
                    "bind",
                    {}
                  )(
                    <Select
                      style={{ width: 130 }}
                      allowClear
                      placeholder="绑定状态"
                    >
                      <Option value="INSTALL"> 已绑定</Option>
                      <Option value="UNINSTALL"> 未绑定</Option>
                    </Select>
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator("status", {
                    initialValue: "ALL",
                  })(
                    <Select style={{ width: 130 }} placeholder="安装状态">
                      <Option value="ALL"> 全部状态</Option>
                      <Option value="INSTALL"> 已安装</Option>
                      <Option value="UNINSTALL"> 未安装</Option>
                    </Select>
                  )}
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    搜索
                  </Button>
                </Form.Item>
              </Form>
            </Col>
            <Col span={4} align="right">
              <Button
                disabled={selectedRowKeys.length == 0}
                style={{ marginRight: 10 }}
                onClick={this.versionUpdateOpen}
                type="primary"
              >
                更新
              </Button>
              <Button
                type="primary"
                onClick={() => this.setState({ visible: true })}
              >
                新增设备
              </Button>
            </Col>
          </Row>
        </div>
        <div className="content">
          <Table
            rowSelection={{
              selectedRowKeys,
              onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                  selectedRowKeys,
                  selectedRows: selectedRows.filter(
                    (item) => item.bind == true
                  ),
                });
              },
            }}
            dataSource={list}
            rowKey="capsuleId"
            pagination={{
              showTotal: () => `共${total}条`,
              total: total,
              current: listQuery.pageNum,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getEquipmentList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getEquipmentList()
                );
              },
            }}
          >
            <Column title="设备号" dataIndex="capsuleNo" key="capsuleNo" />
            <Column title="控制板编号" dataIndex="roboId" key="roboId" />
            <Column
              title="设备类型"
              dataIndex="type"
              key="type"
              render={this.renderType}
            />
            <Column
              title="设备模板"
              dataIndex="templateName"
              key="templateName"
            />
            <Column
              title="绑定状态"
              dataIndex="bind"
              key="bind"
              render={(text) => (text ? "已绑定" : "未绑定")}
            />
            <Column
              title="使用商户"
              dataIndex="companyName"
              key="companyName"
              width="15%"
            />
            <Column
              title="安装状态"
              dataIndex="status"
              key="status"
              render={(text) => (text === "INSTALL" ? "已安装" : "未安装")}
            />
            <Column
              title="软件版本"
              dataIndex="versionName"
              key="versionName"
            />
            <Column
              title="硬件版本"
              render={(record) =>
                record.bind ? (
                  <a onClick={() => this.viewHardwareVersion(record)}>查看</a>
                ) : null
              }
            />
            <Column
              width={110}
              title={() => (
                <React.Fragment>
                  <span>操作</span>
                  <Tooltip
                    placement="top"
                    title="未绑定商户的设备支持编辑和删除"
                  >
                    <div
                      style={{
                        display: "inline-block",
                        lineHeight: "18px",
                        width: 18,
                        height: 18,
                        backgroundColor: "#FAAD14",
                        textAlign: "center",
                        color: "#FFF",
                        borderRadius: 9,
                        paddingLeft: 5,
                        cursor: "pointer",
                      }}
                    >
                      ？
                    </div>
                  </Tooltip>
                </React.Fragment>
              )}
              render={(record) => {
                return record.bind ? (
                  <a onClick={() => this.versionUpdateOpen(record)}>更新</a>
                ) : (
                  <React.Fragment>
                    <a onClick={() => this.editEquipment(record)}>编辑</a>
                    <Divider type="vertical" />
                    <Popconfirm
                      title="确定删除此设备信息？删除后数据不可恢复。"
                      onConfirm={() => this.confirmDelete(record.capsuleId)}
                      okText="确定"
                      cancelText="取消"
                    >
                      <a>删除</a>
                    </Popconfirm>
                  </React.Fragment>
                );
              }}
            />
          </Table>
        </div>
        <AddEquipmentModal
          equipmentInfo={equipmentInfo}
          visible={visible}
          handleCancel={this.handleCancel}
          getEquipmentList={this.getEquipmentList}
        ></AddEquipmentModal>
        <VersionUpdate
          versionUpdateVisible={versionUpdateVisible}
          versionUpdateCancel={this.versionUpdateCancel}
          selectedRowKeys={selectedRowKeys}
          capsuleIdList={capsuleIdList}
          clearSelected={this.clearSelected}
          hardwarePositionList={hardwarePositionList}
        ></VersionUpdate>
        <Modal
          width={700}
          title="硬件版本"
          visible={viewHardwareVersionVisible}
          footer={false}
          onCancel={this.viewHardwareVersionCancel}
        >
          <Table
            dataSource={hardwareVersionList}
            rowKey="positionName"
            pagination={false}
          >
            <Column
              title="硬件部位"
              dataIndex="positionName"
              key="positionName"
            />
            <Column title="版本号" dataIndex="version" key="version" />
          </Table>
        </Modal>
      </div>
    );
  }
}
export default Form.create()(RetailEquipment);
